import React, { useContext, useEffect, useState } from "react";
import LabCompilanceComponent from "../../components/LabCompilanceComponent";
import { toast } from "react-toastify";
import useAxios from "../../common/hook/useAxios";
import { AuthContext } from "../../context/AuthContext";
import { formatDate } from "../../constant";

const LabCompilance = () => {
  const { request } = useAxios();
  const { user } = useContext(AuthContext);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [tableData, setTableData] = useState([]);
  const [isCheckedIn, setIsCheckedIn]=useState(false)
  useEffect(() => {
    if(user?.PracticeID) {
    getData();
    }
  }, [user]);
  
  const getData = () => {
    const FromDate = formatDate(fromDate);
    const ToDate = formatDate(toDate);
    const url = `${process.env.REACT_APP_TEMPLATES_URL}/LabCompliance?sInputJSON={"objLab":{"PracticeId":"${user?.PracticeID}","FromDOS":"${FromDate}","ToDOS":"${ToDate}", "isCheckedIn":${isCheckedIn ? 1 : 0}}}`;
    request(url, {
      headers: {
        Authorization: `Bearer ${user?.AuthToken}`,
      },
      
      method: "GET",
    })
      .then((res) => {
        setTableData(res);
      })
      .catch(() => {
        toast.error("Error occurred in lab compliance", {
          autoClose: 3000,
        });
      });
  };
  return (
    <div>
      <LabCompilanceComponent
        tableData={tableData}
        setFromDate={setFromDate}
        setToDate={setToDate}
        fromDate={fromDate}
        toDate={toDate}
        handleSearch={getData}
        isCheckedIn={isCheckedIn}
        setIsCheckedIn={setIsCheckedIn}
      />
    </div>
  );
};

export default LabCompilance;
